'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMLabelTop = function OMLabelTop(props) {var
  isMobile = props.isMobile,inMultiPin = props.inMultiPin,title = props.title;

  var renderIcon = function renderIcon() {return (
      _react2.default.createElement('div', { className: 'icon icon-top-promotion-active', title: title },
        _react2.default.createElement('i', { className: 'path1' }),
        _react2.default.createElement('i', { className: 'path2' }),
        _react2.default.createElement('i', { className: 'path3' })));};



  return (
    !(isMobile && inMultiPin) && renderIcon());

};


OMLabelTop.propTypes = {
  label: _propTypes2.default.string,
  title: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  inMultiPin: _propTypes2.default.bool };exports.default =


OMLabelTop;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMLabelTop/OMLabelTop.js
// module id = 2710
// module chunks = 0